// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GzKP","left":"styles_left__34bmz"};